/**
 * MUI Theme Factory
 * Creates light and dark themes with minimalist design system
 */

import { createTheme } from '@mui/material/styles';
import { lightThemePalette, lightTypography, lightComponentOverrides } from './lightTheme';
import { darkThemePalette, darkTypography, darkComponentOverrides } from './darkTheme';

/**
 * Create theme based on mode (light/dark)
 * @param {string} mode - 'light' or 'dark'
 * @returns {Theme} MUI theme object
 */
export const getDesignTokens = (mode = 'light') => {
  const isLight = mode === 'light';

  return {
    palette: isLight ? lightThemePalette : darkThemePalette,

    typography: isLight ? lightTypography : darkTypography,

    spacing: 8, // 8px grid system base unit

    shape: {
      borderRadius: 12, // Default border radius for cards
    },

    // Component-specific overrides
    components: isLight ? lightComponentOverrides : darkComponentOverrides,
  };
};

/**
 * Create full MUI theme object
 * @param {string} mode - 'light' or 'dark'
 * @returns {Theme} Complete MUI theme
 */
export const createAppTheme = (mode = 'light') => {
  const tokens = getDesignTokens(mode);

  return createTheme({
    palette: {
      mode, // ← ADD THIS to set theme.palette.mode correctly
      ...tokens.palette,
    },
    typography: tokens.typography,
    spacing: tokens.spacing,
    shape: tokens.shape,
    components: tokens.components,
    breakpoints: {
      values: {
        xs: 0,
        sm: 480,
        md: 768,
        lg: 1024,
        xl: 1280,
      },
    },
  });
};

export default createAppTheme;
